/*
  <colorway-preview> — hover / focus preview for sections/colorway-showcase.liquid ("split" layout).

  Each swatch is a normal link to its colour's product page. Pointing at a swatch, or tabbing to
  it, shows that colour in the room shot and updates the caption ("Shown: Charcoal Smudge C7902");
  clicking still opens the product. Swatches carry what the swap needs:
    data-colorway-preview  marks a swatch
    data-src               the colour's room shot at width=1200 (other widths are derived)
    data-alt / data-caption / data-focal
  The room shot is the <img> inside [data-colorway-frame]; the caption is [data-colorway-caption].
  Without this script the section simply shows the selected colour.
*/
const WIDTHS = [360, 540, 720, 960, 1200, 1440];
const withWidth = (url, width) => url.replace(/([?&]width=)\d+/, `$1${width}`);

class ColorwayPreview extends HTMLElement {
  connectedCallback() {
    this.image = this.querySelector('[data-colorway-frame] img');
    this.caption = this.querySelector('[data-colorway-caption]');
    this.swatches = Array.from(this.querySelectorAll('[data-colorway-preview]'));
    if (!this.image || !this.swatches.length) return;

    this.current = this.swatches.find((swatch) => swatch.classList.contains('is-active')) || null;
    this.abort = new AbortController();
    const { signal } = this.abort;
    const preview = (event) => {
      const swatch = event.target.closest('[data-colorway-preview]');
      if (swatch && this.contains(swatch)) this.show(swatch);
    };
    this.addEventListener('pointerover', preview, { signal });
    this.addEventListener('focusin', preview, { signal });
  }

  disconnectedCallback() {
    if (this.abort) this.abort.abort();
  }

  show(swatch) {
    const src = swatch.dataset.src;
    if (!src || swatch === this.current) return;
    this.current = swatch;

    this.swatches.forEach((item) => item.classList.toggle('is-active', item === swatch));
    this.image.srcset = WIDTHS.map((width) => `${withWidth(src, width)} ${width}w`).join(', ');
    this.image.src = src;
    this.image.alt = swatch.dataset.alt || '';
    this.image.style.objectPosition = swatch.dataset.focal || '';
    if (this.caption) this.caption.textContent = swatch.dataset.caption || '';
  }
}

if (!customElements.get('colorway-preview')) {
  customElements.define('colorway-preview', ColorwayPreview);
}
